// JustSourced theme.js
document.addEventListener('DOMContentLoaded', function () {

  // ---------- Gallery thumbnail swap ----------
  document.querySelectorAll('.gal .thumbs .t').forEach(function (t) {
    t.addEventListener('click', function () {
      const gallery = t.closest('.gal');
      if (!gallery) return;
      gallery.querySelectorAll('.thumbs .t').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      const main = gallery.querySelector('.main img');
      if (main && t.dataset.src) main.src = t.dataset.src;
    });
  });

  // ---------- Sticky Add-to-Cart bar ----------
  const cta = document.querySelector('[data-main-cta]');
  const satc = document.querySelector('[data-sticky-atc]');
  if (cta && satc) {
    function updateSatc() {
      const rect = cta.getBoundingClientRect();
      satc.classList.toggle('on', rect.bottom < 0);
    }
    window.addEventListener('scroll', updateSatc, { passive: true });
    window.addEventListener('resize', updateSatc);
    updateSatc();
    const stickyBtn = satc.querySelector('button, .btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) form.submit();
      });
    }
  }

  // ---------- Variant picker ----------
  const picker = document.querySelector('[data-variant-picker]');
  const productJsonEl = document.querySelector('[data-product-json]');
  if (picker && productJsonEl) {
    let productData;
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) { return; }

    // Precompute which values are still available given current selection
    function getSelectedOptions() {
      const opts = [];
      picker.querySelectorAll('.option-group').forEach(function (g) {
        const checked = g.querySelector('input[type=radio]:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(options) {
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function updateUI(variant) {
      // Hidden variant id input in main form
      const idInput = document.querySelector('[data-variant-id]');
      if (idInput && variant) idInput.value = variant.id;

      // Price display
      if (variant) {
        const priceEl = document.querySelector('[data-price]');
        const compareEl = document.querySelector('[data-compare-price]');
        const saveEl = document.querySelector('[data-save-amount]');
        if (priceEl) priceEl.textContent = variant.price_formatted;
        if (compareEl && saveEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = variant.compare_at_price_formatted;
            compareEl.style.display = '';
            priceEl.classList.add('sale');
            const saveAmount = variant.compare_at_price - variant.price;
            saveEl.textContent = 'Save ' + formatCentsUsingTemplate(saveAmount, variant.price, variant.price_formatted);
            saveEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
            saveEl.style.display = 'none';
            priceEl.classList.remove('sale');
          }
        }
      }

      // Main image
      if (variant && variant.featured_image) {
        const mainImg = document.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = variant.featured_image;
      }

      // Availability + CTA
      const ctaBtn = document.querySelector('[data-main-cta]');
      const ctaText = document.querySelector('[data-cta-text]');
      if (variant && ctaBtn) {
        ctaBtn.disabled = !variant.available;
        if (!variant.available && ctaText) {
          ctaText.textContent = 'Sold out';
        } else if (variant.available && ctaText && ctaBtn.dataset.originalText) {
          ctaText.textContent = ctaBtn.dataset.originalText;
        }
      }

      // URL query string
      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    // Rough money formatter fallback — just scales cents into the current template
    function formatCentsUsingTemplate(amountCents, refCents, refFormatted) {
      if (!refFormatted) return (amountCents / 100).toFixed(2);
      // Replace the numeric portion of refFormatted with our new amount
      return refFormatted.replace(/[0-9,.]+/, (amountCents / 100).toFixed(2));
    }

    // Store original CTA text for restoration
    const ctaBtn = document.querySelector('[data-main-cta]');
    const ctaText = document.querySelector('[data-cta-text]');
    if (ctaBtn && ctaText) ctaBtn.dataset.originalText = ctaText.textContent.trim();

    // Listen for radio changes
    picker.querySelectorAll('input[type=radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Toggle .on class on labels
        const group = radio.closest('.option-group');
        group.querySelectorAll('.opt').forEach(function (l) { l.classList.remove('on'); });
        radio.closest('.opt').classList.add('on');
        // Update the "Selected: X" text in the label
        const selectedText = group.querySelector('[data-selected-value]');
        if (selectedText) selectedText.textContent = radio.value;

        const opts = getSelectedOptions();
        const variant = findVariant(opts);
        updateUI(variant);
      });
    });

    // Also handle direct click on the label (in case of ancient browsers)
    picker.querySelectorAll('.opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        const radio = opt.querySelector('input[type=radio]');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }
});
